<template>
  <div class="top-box">
    <header class="top-header">
      <h1 class="top-logo"><img src="../assets/site_logo.png" alt="みちのく震録伝" /></h1>
      <h2 class="top-title">みちのく震録伝<span class="site-name">自然災害アーカイブβ2.0</span><br>
        <span class="site-copy">東日本大震災に関するあらゆる記憶、記録、事例、知見を収集し、国内外や未来に共有します</span></h2>
    </header>

    <nav>
      <div class="top-search-box">
        <div class="top-search-input"><input type="text" v-model="keyword"></div>
        <div class="top-search-btn-box"><a href="#" v-on:click="search"><img src="../assets/search.png" alt=""/><span>検 索</span></a></div>
      </div>
    </nav>
    <!-- wrapper start -->
    <div class="wrapper top-wrapper">

      <!-- contents start -->
      <div class="top-contents">

        <div class="tagcloud-box">
          <span v-for="keyword in keywords" v-bind:key="keyword.value">
            <a href="#" v-on:click="setFreeword(keyword.value)">{{ keyword.value }}</a>
          </span>
        </div>

      </div>
      <!-- contents end -->

    </div>
    <!-- wrapper end -->
  </div>
</template>
<script>
 import { RepositoryFactory } from './../repositories/RepositoryFactory'
 import { resource } from './../repositories/itemsRepository'
 import { mapState } from 'vuex'

 const ItemsRepository = RepositoryFactory.get('items')

 export default {
     name: 'top-component',
     computed: mapState(['freeword']),
     data(){
         return {
             keywords: [],
             keyword : ""
         };
     },
     created(){
         this.fetch()
     },
     updated(){
     },
     methods:{
         async fetch(){
             console.log("res:", resource)

             const { data } = await ItemsRepository.getResource(resource);
             this.keywords = data.channel.facetField.filter(function(element){
                 return (element.name =="keyword");
             })[0].valueList;
         },

         setFreeword(keyword){
             this.keyword = keyword;
         },

         search(){
             this.$router.push({ path: '/result', query: { freeword : this.keyword } })
         }
     }
 }
 
</script>
<style>


 /*---------------------------------
    
    top
    
    ----------------------------------*/

 html{
     min-height: 100%;
     position: relative;
 }

 body.top {
     margin-bottom: 230px;
 }

 .top-header {
     margin: 80px auto 0;
     padding:0;
     width: 100%;
     height: 250px;
     text-align: center;
 }


 .top-wrapper {
     clear: both;
     width: 100%;
     /*min-width: 1000px;
        background: url(../img/common/bg.png) repeat left top;*/
 }

 .top-contents {
     width: 500px;
     margin: 30px auto ;
     box-sizing: border-box;
     text-align: center;
 }

 /*---------------------------------

    top

    ----------------------------------*/

 /*---------------------------------
    Header
    ----------------------------------*/

 header h1.top-logo {
     float: none;
     width: 130px;
     height: 130px;
     margin: 0 auto;
 }

 header h1.top-logo img{
     width: 100% ;
     height: auto;
 }

 header h2.top-title {
     margin: 10px;
     float: none;
     font-size: 165%;
     letter-spacing: 0.01em;
 }

 header h2.top-title .site-copy{
     font-size: 45%;
     font-weight: normal;
 }

 /*---------------------------------
    search-box
    ----------------------------------*/

 .top-search-box {
     margin: 0 auto;
     width: 500px;
     padding: 15px 0;
     box-sizing: border-box;
     overflow: hidden;
     position: relative;
 }

 .top-search-input {
     box-sizing: border-box;
     padding-right: 145px;
     width: 100%;
 }

 .top-search-input input {
     font-size: 16px;
     padding: 0 10px;
     line-height: 40px;
     width: 100%;
     height: 40px;
     border: 1px solid #332C59;
     color: #332C59;
     box-sizing: border-box;
     -webkit-appearance: none;
     border-radius: 0;
	 background-color: #fff;
 }

 .top-search-btn-box {
     margin: 0;
     width: 145px;
     position: absolute;
     right: 0;
     top: 15px;
 }
 .top-search-btn-box ul li {
     padding-left: 15px;
     border-left: 1px solid #332C59;
 }
 .top-search-btn-box a {
     width: 130px;
     height: 40px;
     display: block;
     margin-left: 15px;
     float: left;
     padding: 0;
     text-align: center;
     line-height: 38px;
     background-color: #332C59;
     font-size: 110%;
     color: #fff !important;
     box-sizing: border-box;
     /*letter-spacing: 0.1em;*/
	 font-weight: bold;
 }



 .top-search-btn-box a img{
     vertical-align: middle;
     margin-right:5px;
 }

 .tagcloud-box a {
     display: inline-block;
     margin-right: 15px;
 }

 /*---------------------------------
    Footer
    ----------------------------------*/

.top-footer {
     position: relative;
     position: absolute !important;
     bottom: 0;
     left: 0;
     right: 0;
 }
 
 
 @media screen and (max-width:740px) {
 
 /*top*/

header.top-header {
	margin: 15px 0;
	height: auto;
}

header br {
	display: none;
}

header h1.top-logo {
	width: 110px;
	height: 110px;
	margin: 10px auto;
}

header h2.top-title {
	margin: 0;
	padding: 0 20px;
	font-size: 130%;
	line-height: 1.4;
}

header h2.top-title .site-name{
	display: block;
	margin: 0;
}

header h2.top-title span.site-copy{
	font-size: 65%;
	font-weight: normal;
	display: inline-block;
	margin: 10px 30px;
}

.top-wrapper {
	margin: 10px 0;
	font-size: 95%;
}

.top-contents {
	width: 75%;
	margin: 0 auto;
	text-align: center;
}

.top-search-box {
	padding: 10px 0;
	overflow: inherit;
	width: 85%;
}

.top-search-input {
	box-sizing: border-box;
	padding-right: 40px;
	padding-left: 0;
	width: 100%;
}

.top-search-btn-box {
	width: 40px;
	top: 10px;
}

.top-search-btn-box a {
	width: 40px;
	text-align: center;
	margin-left: 0;
}

.top-search-btn-box a img{
	margin-right: -3px;
}

.top-search-btn-box a span{
	display: none;
}


.term-box {
	bottom: 130px;
}

body.top {
	margin-bottom: 200px;
}

}

 

</style>
